export default __webpack_public_path__ + "static/media/home.29af94ef.webp";